export default class DtoDangerTable {
    constructor(obj) {
        this.idDanger = obj.idDanger // Option[Long] = None,
        this.idDiag = obj.idDiag // Option[Long] = None,
        this.idStructure = obj.idStructure // Option[Long] = None,
        this.familyType = obj.familyType // Option[Long] = None,
        this.step = obj.step // Option[Long] = None,
        this.dangerType = obj.dangerType // Option[Long] = None,
        this.categories = obj.categories // Option[String] = None,
        this.siteType = obj.siteType // Option[Long] = None,
        this.siteCode = obj.siteCode // Option[Long] = None,
        this.dangerGroup = obj.dangerGroup // Option[Long] = None,
        this.precision = obj.precision // Option[String] = None,
        this.frequency = obj.frequency // Option[Long] = None,
        this.severity = obj.severity // Option[Long] = None,
        this.groupRisk = obj.groupRisk // Option[String] = None,
        this.implementation = obj.implementation // Option[String] = None,
        this.onSiteMeasure = obj.onSiteMeasure // Option[Boolean] = None,
        this.followMeans = obj.followMeans // Option[String] = None,
        this.monitoringFrequency = obj.monitoringFrequency // Option[String] = None,
        this.monitoringContributor = obj.monitoringContributor // Option[String] = None,
        this.correctionAction = obj.correctionAction // Option[String] = None,
        this.detectability = obj.detectability // Option[Long] = None,
        this.synthesis = obj.synthesis // Option[String] = None,
    }
}
